module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Baianat opportunities","pageDesc":"See all the open opportunities inside Baianat and apply to join our team.","mantra":"Discover our open |opportunities."},"ar":{"pageTitle":"الفرص المتاحة","pageDesc":"قم بالاطلاع على كل الفرص المتاحة داخل بيانات وتقدم للانضمام إلى فريقنا.","mantra":"اكتشف جميع |الفرص المتاحة."}}')
  delete Component.options._Ctor
}
